import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';
import { interactionContext as InteractionContext } from './interactionContext';

const AssessmentIntroduction = ({ children, ...props }) => {
  const interactionContext = useContext<any>(InteractionContext);

  const [img, text] = children;

  const { includeMedia = true } = interactionContext.props;

  const imgProps = img?.props?.children[1]?.props;

  const {
    width: _imgWidth_,
    height: _imgHeight_,
    imgContainerHeight,
  } = imgProps;

  return (
    <Box
      sx={{
        padding: '20px',
      }}
    >
      {includeMedia && (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            margin: '20px 0',
            img: {
              //
            },
          }}
        >
          {!window.dev() ? (
            <_>
              <div
                style={{
                  width: _imgWidth_,
                  maxHeight: `${50 + imgContainerHeight}vh`,
                  aspectRatio: `${(_imgWidth_ - imgContainerHeight * 4) /
                    _imgHeight_}`,
                }}
              >
                {img}
              </div>
            </_>
          ) : (
            img
          )}
        </Box>
      )}

      <Box
        sx={{
          marginBottom: '20px',
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

export default AssessmentIntroduction;
